import React from "react";
import OtpInput from "react-otp-input";
import "./CustomOTPInput.css";

const CustomOTPInput = ({
  value,
  onChange,
  onFilled,
  numInputs = 6,
  autoFocus = true
}) => {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={numInputs}
      renderSeparator={<span style={{ width: 5 }}></span>}
      shouldAutoFocus={autoFocus}
      onPaste={(evt) => {
        console.log("evt: ",evt.clipboardData.getData('text'))
        if(evt.clipboardData.getData('text').length == numInputs && onFilled)
          onFilled(evt.clipboardData.getData('text'));
      }}
      renderInput={(props, index) => (
        <input
          {...props}
          type="number"
          // autoFocus={autoFocus && index === 0}
          onChange={(evt) => {
            // just passing the event through
            props.onChange(evt)
            // checking if all fields are filled and calling onFilled
            if ((value+evt.target.value).length == numInputs && onFilled != null){
              onFilled();
            }
          }}
          className="otp-input"
        />
      )}
    />
  );
};

export default CustomOTPInput;